export const COLORS = {
    WHITE: '#f4f4f4',
    BLACK: '#0d0d0d',
    GREEN: '#7f7d6c',
    WHITE_NOT_ACTIVE: '#ffffff66',
} as const;
